
import CardEdit from "../../../assets/outline/CardEdit.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function CardEditIcon({ className, dataTestid = "CardEditIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <CardEdit data-testid={dataTestid} className={classes} {...rest} />
  );
}
